import React, { type ComponentPropsWithoutRef } from 'react';
import { inject, observer } from 'mobx-react';
import { MixedMediaStore } from '../../../stores/MixedMediaStore';

type NativeImageProps = ComponentPropsWithoutRef<'img'>;
export interface SmartImageProps extends NativeImageProps {
    mixedMediaStore?: MixedMediaStore;
}

function isAiImageSource(src: NativeImageProps['src']): boolean {
    return typeof src === 'string' && /-AI\.[a-z0-9]+(?:[?#].*)?$/i.test(src);
};

export const SmartImage = inject('mixedMediaStore')(observer(
    ({ src, alt = '', mixedMediaStore, ...props }: SmartImageProps) => {
        if (!mixedMediaStore) return null;

        const aiHint = mixedMediaStore.mainStore.localization.generalL10n.aiAltPrefix;
        const shouldAppendSuffix =
            alt.length > 0 &&
            isAiImageSource(src) &&
            aiHint.length > 0 &&
            !alt.startsWith(aiHint);

        const finalAlt = shouldAppendSuffix
            ? `${aiHint} - ${alt}`
            : alt;

        return <img {...props} src={src} alt={finalAlt} />;
    },
));

export default SmartImage;
